module.exports = "../../../../platform/assets/pageMainIcon/business_yewuchulilei5.svg";